import {
  GET_BROWSE_ERROR,
  GET_BROWSE_REQUEST,
  GET_BROWSE_SUCCESS,
  GET_TOPICS_REQUEST,
  GET_TOPICS_SUCCESS,
  GET_TOPICS_ERROR,
} from "../../store/actionTypes";
import apiService from "../../util/ApiService";

export const getViewModel = async (dispatch, browsePath, params) => {
  try {
    dispatch({ type: GET_BROWSE_REQUEST, browsePath });
    const viewModel = await apiService.getBrowse(browsePath, params);
    dispatch({
      type: GET_BROWSE_SUCCESS,
      viewModel,
      browsePath,
    });
  } catch (err) {
    dispatch({
      type: GET_BROWSE_ERROR,
      browsePath,
      statusCode: err.response ? err.response.status : null,
    });
  }
};

// get a single topic view model from the Experience Browse
export const getTopicViewModel = async (dispatch, browsePath, params) => {
  try {
    dispatch({ type: GET_TOPICS_REQUEST, browsePath });
    const viewModel = await apiService.getBrowse(browsePath, params);
    dispatch({
      type: GET_TOPICS_SUCCESS,
      viewModel,
      browsePath,
      ...params,
    });
  } catch (err) {
    dispatch({
      type: GET_TOPICS_ERROR,
      browsePath,
      statusCode: err.response ? err.response.status : null,
    });
  }
};
